import { createSelector } from 'reselect';
import objectToArray from '../../../../common/utils/object-to-array';

const orderSort = (a, b) => a.order - b.order;

const surveysStateSelector = ({ entities: { surveys } = {} }) => surveys;

export const getSurveys = createSelector([surveysStateSelector], surveys => {
  return objectToArray(surveys || {});
});

export const getSurvey = createSelector(
  [surveysStateSelector, (_, { id }) => id],
  (surveys, id) => {
    const survey = (surveys || {})[id];
    return {
      ...survey,
      questionGroups: getQuestionGroups(survey),
    };
  }
);

export const getQuestionGroups = (survey = {}) => {
  const questionGroups = survey.questionGroups || [];
  return questionGroups
    .concat([])
    .sort(orderSort)
    .map(qg => ({
      ...qg,
      questions: getQuestions(qg),
    }));
};

export const getQuestions = questionGroup => {
  const questions = questionGroup.questions || [];
  return questions.concat([]).sort(orderSort);
};



// WEBPACK FOOTER //
// ./src/App/account/selectors/surveys/index.js